/*
 * Mi Carro by RepuestosYA — app
 * Depende de RYAuto (ryauto-core.js). Ver MiCarro-PRD.md §8.
 * El perfil vivo del carro: perfil + superpoderes (varado, mantenimiento, recomprar, viaje, raro).
 */
(function () {
  'use strict';

  /* ============================ base de conocimiento (PRD §10) ============ */
  var EMERGENCIES = [
    { key: 'no_enciende', label: 'No enciende', emoji: '🔑', urgency: 'media', parts: ['Batería', 'Alternador', 'Motor de arranque', 'Bujías', 'Fusibles'] },
    { key: 'se_calento', label: 'Se calentó', emoji: '🌡️', urgency: 'alta', safety: true, parts: ['Radiador', 'Termostato', 'Mangueras', 'Abanico (electroventilador)', 'Tapón de radiador', 'Bomba de agua'] },
    { key: 'se_apago', label: 'Se apagó andando', emoji: '🛑', urgency: 'media', parts: ['Bomba de combustible', 'Filtro de combustible', 'Sensor de cigüeñal', 'Batería', 'Alternador'] },
    { key: 'no_frena', label: 'No frena bien', emoji: '🦶', urgency: 'alta', safety: true, parts: ['Pastillas (balatas)', 'Discos', 'Líquido de frenos', 'Mangueras de freno', 'Bomba de frenos'] },
    { key: 'se_poncho', label: 'Se pinchó', emoji: '🛞', urgency: 'baja', parts: ['Llanta', 'Kit de parche', 'Válvula'] },
    { key: 'huele_quemado', label: 'Huele a quemado', emoji: '🔥', urgency: 'alta', safety: true, parts: ['Banda / faja', 'Embrague', 'Frenos', 'Cables eléctricos', 'Aceite'] },
    { key: 'perdio_aceite', label: 'Perdió aceite', emoji: '🛢️', urgency: 'media', parts: ['Empaques', 'Retenedor', 'Filtro de aceite', 'Tapón de cárter', 'Aceite'] },
    { key: 'ruido_fuerte', label: 'Hace ruido fuerte', emoji: '🔊', urgency: 'media', parts: ['Mofle / escape', 'Rodamientos (balineras)', 'Banda', 'Suspensión'] }
  ];

  var SYMPTOMS = [
    { key: 'tiembla', label: 'Tiembla', emoji: '📳', mecanico: 'Siento vibración (al frenar o a cierta velocidad).', revisar: ['Discos', 'Pastillas', 'Balanceo de llantas', 'Soportes de motor'], preguntar: ['¿Revisamos discos y balanceo antes de cambiar piezas grandes?'], parts: ['Discos', 'Pastillas (balatas)', 'Soportes de motor'] },
    { key: 'suena', label: 'Suena / hace ruido', emoji: '🔊', mecanico: 'Escucho un ruido (al frenar, al girar o en los topes).', revisar: ['Pastillas', 'Rodamientos', 'Rótulas', 'Terminales', 'Amortiguadores', 'Escape'], preguntar: ['¿De dónde viene el ruido y qué lo causa?'], parts: ['Pastillas (balatas)', 'Rótulas', 'Amortiguadores', 'Rodamientos'] },
    { key: 'huele', label: 'Huele', emoji: '👃', mecanico: 'Huelo algo raro (quemado, gasolina o dulce).', revisar: ['Banda', 'Frenos', 'Fuga de combustible', 'Coolant', 'Aceite'], preguntar: ['¿Es seguro seguir manejando hasta revisarlo?'], parts: ['Banda / faja', 'Coolant', 'Líquido de frenos'] },
    { key: 'se_calienta', label: 'Se calienta', emoji: '🌡️', mecanico: 'La temperatura sube más de lo normal.', revisar: ['Coolant', 'Termostato', 'Radiador', 'Abanico', 'Bomba de agua'], preguntar: ['¿La causa es una fuga o el termostato?'], parts: ['Termostato', 'Radiador', 'Coolant', 'Bomba de agua'] },
    { key: 'no_acelera', label: 'No acelera', emoji: '🐢', mecanico: 'Pierde fuerza o no responde al acelerar.', revisar: ['Filtro de aire', 'Filtro de combustible', 'Bujías', 'Sensores', 'Embrague'], preguntar: ['¿Probamos lo más barato (filtros y bujías) primero?'], parts: ['Filtro de aire', 'Filtro de combustible', 'Bujías'] },
    { key: 'se_va_lado', label: 'Se va de lado', emoji: '↔️', mecanico: 'Se jala hacia un lado al manejar.', revisar: ['Alineación', 'Presión de llantas', 'Frenos', 'Suspensión'], preguntar: ['¿Necesita alineación o hay algo en la suspensión?'], parts: ['Amortiguadores', 'Rótulas', 'Terminales'] },
    { key: 'gasta_mas', label: 'Gasta más gasolina', emoji: '⛽', mecanico: 'Está rindiendo menos gasolina que antes.', revisar: ['Filtros', 'Bujías', 'Sensores O2', 'Presión de llantas'], preguntar: ['¿Qué puede estar causando el consumo?'], parts: ['Filtro de aire', 'Bujías', 'Sensor de oxígeno'] },
    { key: 'cuesta_encender', label: 'Le cuesta encender', emoji: '🔋', mecanico: 'Le cuesta arrancar (en frío o siempre).', revisar: ['Batería', 'Bujías', 'Bomba / filtro de combustible', 'Motor de arranque'], preguntar: ['¿Es la batería o el sistema de arranque/combustible?'], parts: ['Batería', 'Bujías', 'Motor de arranque'] }
  ];

  var TRIP_CHECKLIST = ['Aceite', 'Agua / coolant', 'Frenos', 'Luces', 'Presión de llantas', 'Llanta de repuesto', 'Gato hidráulico', 'Herramientas', 'Escobillas', 'Batería'];
  var TRIP_KIT = ['Coolant', 'Focos', 'Escobillas', 'Líquido de frenos', 'Cables pasacorriente'];
  var MAINT_TYPES = ['Cambio de aceite', 'Frenos', 'Batería', 'Suspensión', 'Filtro', 'Llantas', 'A/C', 'Afinamiento', 'Otro'];
  var USE_TYPES = ['Diario', 'Trabajo', 'Familiar', 'Fin de semana'];

  var R; // alias RYAuto
  var el, esc;

  /* ============================ init / mount ============================== */
  function boot() {
    R = window.RYAuto; el = R.ui.el; esc = R.ui.escape;
    document.querySelectorAll('[data-mi-carro]').forEach(mount);
  }
  if (!window.__mcSecListener) {
    window.__mcSecListener = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (!window.RYAuto) return;
      (e.target || document).querySelectorAll('[data-mi-carro]').forEach(mount);
    });
  }

  function mount(root) {
    if (root.__mcMounted) return;
    root.__mcMounted = true;

    var app = { root: root };
    app.render = function () { render(app); };
    R.ui.on('vehicle:change', app.render);
    R.ui.on('vehicle:active', app.render);
    render(app);

    // deep-links: #/varado, #/viaje, ...
    handleHash(app);
    window.addEventListener('hashchange', function () { handleHash(app); });
  }

  function handleHash(app) {
    var h = (location.hash || '').replace(/^#\/?/, '');
    if (!h) return;
    var v = R.vehicles.active();
    if (!v && h !== 'crear') return;
    var map = { varado: openVarado, viaje: openViaje, raro: openRaro, mantenimiento: openMantenimiento, recomprar: openRecomprar, instalar: openInstalar, crear: function () { openVehicleForm(app); } };
    if (map[h]) { map[h](app); history.replaceState(null, '', location.pathname + location.search); }
  }

  /* ============================ render principal ========================== */
  function render(app) {
    var v = R.vehicles.active();
    app.root.textContent = '';
    var wrap = el('div', { class: 'rya-app mc-app rya-section-pad' });
    if (!v) wrap.appendChild(renderOnboarding(app));
    else wrap.appendChild(renderDashboard(app, v));
    app.root.appendChild(wrap);
  }

  /* ----------------------------------- onboarding ------------------------ */
  function renderOnboarding(app) {
    var cfg = R.config;
    return el('div', { class: 'mc-onboard rya-stack-lg' }, [
      el('div', { class: 'mc-hero' }, [
        el('div', { class: 'rya-eyebrow', text: cfg.storeName }),
        el('h1', { class: 'rya-h1', text: 'Mi Carro' }),
        el('p', { class: 'rya-sub', text: 'El perfil vivo de tu carro. Guardalo y tenelo a mano para cuando tu carro lo necesite: si se queda varado, antes de viajar, o cuando no te acordás qué repuesto usa.' })
      ]),
      vehicleFormCard(app, null, 'Crear Mi Carro'),
      el('p', { class: 'rya-faint', style: { fontSize: '12px', textAlign: 'center' }, text: '🔒 Tus datos se guardan solo en este teléfono.' })
    ]);
  }

  function vehicleFormCard(app, vehicle, submitLabel) {
    var data = vehicle || {};
    var f = {};
    function field(label, key, opts) {
      opts = opts || {};
      var input = el(opts.tag || 'input', Object.assign({ class: opts.tag === 'select' ? 'rya-select' : 'rya-input', value: data[key] || '', placeholder: opts.ph || '' }, opts.attrs || {}));
      if (opts.tag === 'select') {
        input.appendChild(el('option', { value: '', text: opts.ph || '—' }));
        (opts.options || []).forEach(function (o) { var op = el('option', { value: o, text: o }); if ((data[key] || '') === o) op.selected = true; input.appendChild(op); });
      }
      f[key] = input;
      return el('label', { class: 'rya-field' }, [
        el('span', { class: 'rya-field__label', html: esc(label) + (opts.req ? ' <span class="req">*</span>' : '') }),
        input
      ]);
    }
    var card = el('div', { class: 'rya-card rya-stack' }, [
      el('div', { class: 'rya-grid-2' }, [field('Marca', 'make', { req: true, ph: 'Toyota' }), field('Modelo', 'model', { req: true, ph: 'Corolla' })]),
      el('div', { class: 'rya-grid-2' }, [field('Año', 'year', { req: true, ph: '2012', attrs: { inputmode: 'numeric', maxlength: '4' } }), field('Motor', 'engine', { ph: '1.8' })]),
      el('div', { class: 'rya-grid-2' }, [field('Kilometraje', 'mileage', { ph: '184,000', attrs: { inputmode: 'numeric' } }), field('Ciudad', 'city', { ph: 'Tegucigalpa' })]),
      field('Uso', 'use', { tag: 'select', options: USE_TYPES, ph: '¿Cómo lo usás?' }),
      field('Apodo (opcional)', 'nickname', { ph: 'Mi Corolla' })
    ]);
    var submit = el('button', { class: 'rya-btn rya-btn--accent rya-btn--block', type: 'button', text: submitLabel || 'Guardar', onclick: function () {
      var payload = {};
      Object.keys(f).forEach(function (k) { payload[k] = (f[k].value || '').trim(); });
      if (!payload.make || !payload.model || !payload.year) { R.ui.toast('Marca, modelo y año son necesarios.', { type: 'warn' }); return; }
      if (vehicle) { R.vehicles.update(vehicle.id, payload); R.ui.toast('Carro actualizado.', { type: 'success' }); }
      else { R.vehicles.create(payload); R.track('mc_vehicle_created', {}); R.ui.toast('¡Mi Carro creado!', { type: 'success' }); }
      if (app.__sheet) app.__sheet.close();
      app.render();
    }});
    card.appendChild(submit);
    return card;
  }

  /* ----------------------------------- dashboard ------------------------- */
  function renderDashboard(app, v) {
    var all = R.vehicles.list();
    var head = el('div', { class: 'mc-dash-head rya-stack' });

    // switcher + add
    var top = el('div', { class: 'rya-between' });
    if (all.length > 1) {
      var sel = el('select', { class: 'rya-select mc-switcher', onchange: function () { R.vehicles.setActive(sel.value); } });
      all.forEach(function (x) { var o = el('option', { value: x.id, text: x.nickname || R.vehicles.format(x) }); if (x.id === v.id) o.selected = true; sel.appendChild(o); });
      top.appendChild(sel);
    } else {
      top.appendChild(el('div', { class: 'rya-eyebrow', text: R.config.storeName + ' · Mi Carro' }));
    }
    top.appendChild(el('button', { class: 'rya-btn rya-btn--ghost rya-btn--sm', type: 'button', html: '<span class="rya-btn__ico">＋</span> Carro', onclick: function () { openVehicleForm(app); } }));
    head.appendChild(top);

    // vehicle title card
    var titleCard = el('div', { class: 'rya-card mc-vehicle' }, [
      el('div', { class: 'rya-between' }, [
        el('div', { class: 'rya-grow' }, [
          el('h1', { class: 'rya-h2 mc-vehicle__name', text: v.nickname || R.vehicles.format(v) }),
          el('p', { class: 'rya-muted mc-vehicle__meta', text: [R.vehicles.format(v), v.mileage ? v.mileage + ' km' : '', v.city].filter(Boolean).join(' · ') })
        ]),
        el('button', { class: 'rya-iconbtn', type: 'button', 'aria-label': 'Editar carro', text: '✎', onclick: function () { openVehicleForm(app, v); } })
      ])
    ]);
    head.appendChild(titleCard);

    // open repairs banner
    var open = R.repairs.countOpen(v.id);
    if (open > 0) {
      head.appendChild(el('a', { class: 'rya-card mc-banner', href: R.config.reparacionUrl }, [
        el('span', { class: 'mc-banner__ico', text: '🔧' }),
        el('span', { class: 'rya-grow', html: '<strong>' + open + ' reparación' + (open > 1 ? 'es' : '') + ' abierta' + (open > 1 ? 's' : '') + '</strong><br><span class="rya-muted">Tocá para ver tus reparaciones</span>' }),
        el('span', { class: 'mc-banner__arrow', text: '→' })
      ]));
    }

    // superpower grid
    var tiles = [
      tile('🚨', 'Me quedé varado', 'Mensaje + ubicación', 'danger', function () { openVarado(app); }),
      tile('🧾', 'Guardar algo que le hice', 'Mantenimientos', '', function () { openMantenimiento(app); }),
      tile('🔁', 'Comprar lo mismo otra vez', 'Repuestos guardados', '', function () { openRecomprar(app); }),
      tile('🛣️', 'Voy a salir de viaje', 'Checklist + kit', '', function () { openViaje(app); }),
      tile('🧰', 'Algo se siente raro', 'Qué decirle al mecánico', '', function () { openRaro(app); }),
      tile('🔧', 'Tengo una reparación', 'Organizá lo que pidió el taller', 'accent', function () { goToReparacion({ v: v.id }); })
    ];
    var grid = el('div', { class: 'rya-grid mc-grid' }, tiles);

    // footer
    var footer = el('div', { class: 'mc-foot rya-stack' }, [
      el('div', { class: 'rya-row-wrap' }, [
        el('button', { class: 'rya-btn rya-btn--ghost rya-btn--sm', type: 'button', html: '📲 Agregar a inicio', onclick: function () { openInstalar(app); } }),
        el('button', { class: 'rya-btn rya-btn--ghost rya-btn--sm', type: 'button', html: '↗ Compartir Mi Carro', onclick: function () { shareCar(v); } })
      ]),
      el('p', { class: 'rya-faint', style: { fontSize: '12px' }, text: '🔒 Tus datos se guardan solo en este teléfono.' })
    ]);

    return el('div', { class: 'rya-stack-lg' }, [head, grid, footer]);
  }

  function tile(emoji, label, sub, variant, onClick) {
    return el('button', { class: 'rya-tile' + (variant ? ' rya-tile--' + variant : ''), type: 'button', onclick: onClick }, [
      el('span', { class: 'rya-tile__icon', text: emoji }),
      el('span', { class: 'rya-tile__label', text: label }),
      el('span', { class: 'rya-tile__sub', text: sub })
    ]);
  }

  function openVehicleForm(app, vehicle) {
    app.__sheet = R.ui.sheet({
      title: vehicle ? 'Editar carro' : 'Agregar carro',
      content: [vehicleFormCard(app, vehicle, vehicle ? 'Guardar cambios' : 'Crear Mi Carro')],
      footer: vehicle ? [el('button', { class: 'rya-btn rya-btn--ghost', type: 'button', text: 'Eliminar este carro', onclick: function () {
        if (confirm('¿Eliminar este carro y dejar de verlo en Mi Carro?')) { R.vehicles.remove(vehicle.id); app.__sheet.close(); app.render(); }
      } })] : null
    });
  }

  function shareCar(v) {
    R.track('mc_share', {});
    R.share.any({ title: 'Mi Carro — ' + R.config.storeName, text: 'Este es mi carro en ' + R.config.storeName + ': ' + R.vehicles.format(v) + '. Guardá el tuyo también:', url: location.origin + R.config.miCarroUrl });
  }

  /* ============================ SUPERPODER: varado ======================== */
  function openVarado(app) {
    R.track('mc_superpower_open', { key: 'varado' });
    var v = R.vehicles.active();
    var state = { problem: null, loc: null };
    var body = el('div', { class: 'rya-stack' });

    var step1 = el('div', { class: 'rya-stack' }, [
      el('p', { class: 'rya-sub', text: '¿Qué le pasó a tu carro? Tocá lo que más se parezca.' }),
      chipGroup(EMERGENCIES, function (item) { state.problem = item; renderStep2(); })
    ]);
    body.appendChild(step1);

    var sheet = R.ui.sheet({ title: '🚨 Me quedé varado', content: [body] });

    function renderStep2() {
      body.textContent = '';
      var e = state.problem;
      var msgArea = el('textarea', { class: 'rya-textarea mc-varado__msg', rows: '9' });

      function rebuild() { msgArea.value = R.wa.text(buildVaradoLines(v, state)); }

      var locBtn = el('button', { class: 'rya-btn rya-btn--ghost rya-btn--block', type: 'button', html: '📍 Usar mi ubicación', onclick: function () {
        locBtn.disabled = true; locBtn.innerHTML = 'Obteniendo ubicación…';
        R.geo.locate().then(function (pos) { state.loc = pos; rebuild(); locBtn.innerHTML = '✓ Ubicación lista'; }).catch(function () {
          locBtn.disabled = false; locBtn.innerHTML = '📍 Usar mi ubicación';
          R.ui.toast('No se pudo obtener la ubicación. Podés seguir sin ella.', { type: 'warn' });
        });
      }});

      var stack = el('div', { class: 'rya-stack' });
      stack.appendChild(el('button', { class: 'rya-link', type: 'button', text: '‹ Cambiar problema', onclick: function () { state.problem = null; sheet.close(); openVarado(app); } }));
      if (e.safety) stack.appendChild(el('div', { class: 'rya-alert rya-alert--danger' }, [el('span', { class: 'rya-alert__ico', text: '⚠️' }), el('span', { text: 'Por tu seguridad: parate en un lugar seguro y, si podés, apagá el motor. No sigas manejando hasta revisarlo.' })]));
      stack.appendChild(el('div', { class: 'rya-between' }, [el('strong', { text: e.emoji + ' ' + e.label }), urgencyBadge(e.urgency)]));
      stack.appendChild(locBtn);
      stack.appendChild(el('label', { class: 'rya-field' }, [el('span', { class: 'rya-field__label', text: 'Mensaje (podés editarlo):' }), msgArea]));
      stack.appendChild(relatedPartsBlock(e.parts, v, 'Posibles piezas a revisar'));
      body.appendChild(stack);
      rebuild();

      // acciones (footer del sheet)
      var foot = el('div', { class: 'rya-stack', style: { marginTop: '8px' } }, [
        el('button', { class: 'rya-btn rya-btn--whatsapp rya-btn--block', type: 'button', html: '<span class="rya-btn__ico">🟢</span> Enviar a ' + esc(R.config.storeName), onclick: function () { R.track('mc_varado_send', { target: 'store', problem: e.key }); R.wa.openStore(msgArea.value); } }),
        el('div', { class: 'rya-row' }, [
          el('button', { class: 'rya-btn rya-btn--ghost rya-grow', type: 'button', text: '👨‍🔧 Mi mecánico', onclick: function () { sendToContact('mechanic', msgArea.value, 'mc_varado_send', { target: 'mechanic', problem: e.key }); } }),
          el('button', { class: 'rya-btn rya-btn--ghost rya-grow', type: 'button', text: '👪 Familiar', onclick: function () { sendToContact('family', msgArea.value, 'mc_varado_send', { target: 'family', problem: e.key }); } })
        ]),
        el('div', { class: 'rya-row' }, [
          el('button', { class: 'rya-btn rya-btn--ghost rya-grow', type: 'button', text: '📋 Copiar', onclick: function () { R.clipboard.copy(msgArea.value).then(function (ok) { R.ui.toast(ok ? 'Mensaje copiado.' : 'No se pudo copiar.', { type: ok ? 'success' : 'error' }); }); } }),
          el('button', { class: 'rya-btn rya-btn--ghost rya-grow', type: 'button', text: '🔧 Abrir reparación', onclick: function () { goToReparacion({ nuevo: 1, v: v ? v.id : '', desde: 'varado' }, { title: e.label, problem: e.label, items: e.parts }); } })
        ])
      ]);
      body.appendChild(foot);
    }
  }

  function buildVaradoLines(v, state) {
    var e = state.problem;
    var lines = ['Hola, necesito ayuda. 🚨'];
    if (v) lines.push('Carro: ' + R.vehicles.format(v));
    lines.push('Problema: ' + e.label);
    if (state.loc) lines.push('Ubicación: ' + state.loc.mapsUrl);
    lines.push('Posibles piezas a revisar:');
    e.parts.forEach(function (p) { lines.push('- ' + p); });
    return lines;
  }

  /* ============================ SUPERPODER: mantenimiento ================= */
  function openMantenimiento(app) {
    R.track('mc_superpower_open', { key: 'mantenimiento' });
    var v = R.vehicles.active();
    var body = el('div', { class: 'rya-stack-lg' });
    var sheet = R.ui.sheet({ title: '🧾 Guardar algo que le hice', content: [body] });

    var sel = { type: MAINT_TYPES[0] };
    var fDate = el('input', { class: 'rya-input', type: 'date', value: new Date().toISOString().slice(0, 10) });
    var fKm = el('input', { class: 'rya-input', inputmode: 'numeric', placeholder: v && v.mileage ? v.mileage : 'Kilometraje' });
    var fCost = el('input', { class: 'rya-input', inputmode: 'numeric', placeholder: 'Costo (opcional)' });
    var fNotes = el('textarea', { class: 'rya-textarea', rows: '2', placeholder: 'Notas (taller, marca del repuesto, etc.)' });
    var fWarMonths = el('input', { class: 'rya-input', inputmode: 'numeric', placeholder: 'Meses' });
    var fWarWhere = el('input', { class: 'rya-input', placeholder: '¿Dónde?' });

    var typeChips = chipGroup(MAINT_TYPES.map(function (t) { return { key: t, label: t }; }), function (item) { sel.type = item.label; }, MAINT_TYPES[0]);

    var form = el('div', { class: 'rya-card rya-stack' }, [
      el('div', { class: 'rya-field' }, [el('span', { class: 'rya-field__label', text: '¿Qué le hiciste?' }), typeChips]),
      el('div', { class: 'rya-grid-2' }, [
        el('label', { class: 'rya-field' }, [el('span', { class: 'rya-field__label', text: 'Fecha' }), fDate]),
        el('label', { class: 'rya-field' }, [el('span', { class: 'rya-field__label', text: 'Kilometraje' }), fKm])
      ]),
      el('label', { class: 'rya-field' }, [el('span', { class: 'rya-field__label', text: 'Costo' }), fCost]),
      el('label', { class: 'rya-field' }, [el('span', { class: 'rya-field__label', text: 'Notas' }), fNotes]),
      el('div', { class: 'rya-field' }, [el('span', { class: 'rya-field__label', text: 'Garantía (opcional)' }), el('div', { class: 'rya-grid-2' }, [fWarMonths, fWarWhere])]),
      el('button', { class: 'rya-btn rya-btn--accent rya-btn--block', type: 'button', text: 'Guardar', onclick: save })
    ]);
    body.appendChild(el('div', {}, [el('p', { class: 'rya-sub', text: 'Guardá lo que le hiciste a tu carro. Así, cuando el mecánico te pregunte “¿cuándo le cambiaste eso?”, lo abrís y se lo mostrás.' })]));
    body.appendChild(form);

    var historyWrap = el('div', { class: 'rya-stack' });
    body.appendChild(historyWrap);
    renderHistory();

    function renderHistory() {
      historyWrap.textContent = '';
      var list = R.maintenance.list(v.id);
      historyWrap.appendChild(el('h3', { class: 'rya-card__title', text: 'Historial' }));
      if (!list.length) { historyWrap.appendChild(el('div', { class: 'rya-empty' }, [el('div', { class: 'rya-empty__ico', text: '🗂️' }), el('p', { text: 'Todavía no has guardado nada. Lo que guardes aparecerá aquí.' })])); return; }
      var ul = el('div', { class: 'rya-list' });
      list.forEach(function (m) {
        ul.appendChild(el('div', { class: 'rya-listitem' }, [
          el('div', { class: 'rya-listitem__main' }, [
            el('div', { class: 'rya-listitem__title', text: m.type }),
            el('div', { class: 'rya-listitem__meta', text: [R.ui.date(m.date), m.mileage ? m.mileage + ' km' : '', m.cost ? R.ui.money(m.cost) : ''].filter(Boolean).join(' · ') }),
            m.notes ? el('div', { class: 'rya-listitem__meta', text: m.notes }) : null
          ]),
          el('button', { class: 'rya-iconbtn', 'aria-label': 'Eliminar', text: '🗑', onclick: function () { R.maintenance.remove(m.id); renderHistory(); } })
        ]));
      });
      historyWrap.appendChild(ul);
    }

    function save() {
      var rec = { vehicleId: v.id, type: sel.type, date: fDate.value, mileage: (fKm.value || '').trim(), cost: (fCost.value || '').replace(/\D/g, ''), notes: (fNotes.value || '').trim() };
      if (fWarMonths.value) rec.warranty = { months: fWarMonths.value, where: (fWarWhere.value || '').trim() };
      R.maintenance.add(rec);
      if (rec.mileage) R.vehicles.update(v.id, { mileage: rec.mileage });
      R.track('mc_maintenance_saved', { type: rec.type });
      R.ui.toast('Guardado en tu historial.', { type: 'success' });
      fNotes.value = ''; fCost.value = ''; fWarMonths.value = ''; fWarWhere.value = '';
      renderHistory();
      if (/aceite|frenos|filtro|afinamiento/i.test(rec.type)) offerSaveParts(rec.type);
    }

    function offerSaveParts(type) {
      var suggest = /aceite/i.test(type) ? ['Filtro de aceite', 'Filtro de aire', 'Filtro de cabina'] : /frenos/i.test(type) ? ['Pastillas (balatas)', 'Discos'] : ['Filtro de aire', 'Filtro de aceite'];
      var picks = {};
      var chips = el('div', { class: 'rya-chips' }, suggest.map(function (s) {
        return el('button', { class: 'rya-chip', type: 'button', text: s, onclick: function (ev) { picks[s] = !picks[s]; ev.currentTarget.classList.toggle('is-selected'); } });
      }));
      R.ui.sheet({
        title: 'Guardar repuestos usados',
        content: [el('p', { class: 'rya-sub', text: '¿Querés guardar los repuestos que usaste? Así los recomprás fácil después, sin volver a buscar.' }), chips],
        footer: [el('button', { class: 'rya-btn rya-btn--accent', type: 'button', text: 'Guardar repuestos', onclick: function (ev) {
          var added = 0;
          Object.keys(picks).forEach(function (k) { if (picks[k]) { R.parts.add({ vehicleId: v.id, name: k, query: k }); added++; } });
          R.ui.toast(added ? 'Guardado para recomprar fácil.' : 'No seleccionaste ninguno.', { type: added ? 'success' : 'warn' });
          var root = ev.currentTarget.closest('.rya-sheet'); if (root) root.querySelector('.rya-sheet__close').click();
        } })]
      });
    }
  }

  /* ============================ SUPERPODER: recomprar ===================== */
  function openRecomprar(app) {
    R.track('mc_superpower_open', { key: 'recomprar' });
    var v = R.vehicles.active();
    var body = el('div', { class: 'rya-stack' });
    var sheet = R.ui.sheet({ title: '🔁 Comprar lo mismo otra vez', content: [body] });

    var listWrap = el('div', { class: 'rya-stack' });
    var addName = el('input', { class: 'rya-input rya-grow', placeholder: 'Nombre del repuesto (ej. Filtro de aceite)' });
    var addRow = el('div', { class: 'rya-card' }, [
      el('div', { class: 'rya-field__label', text: '＋ Guardar un repuesto' }),
      el('div', { class: 'rya-row' }, [addName, el('button', { class: 'rya-btn rya-btn--accent', type: 'button', text: 'Guardar', onclick: function () {
        var name = (addName.value || '').trim(); if (!name) { addName.focus(); return; }
        R.parts.add({ vehicleId: v.id, name: name, query: name }); addName.value = ''; R.ui.toast('Repuesto guardado.', { type: 'success' }); renderList();
      } })])
    ]);
    body.appendChild(el('p', { class: 'rya-sub', text: 'Tus repuestos guardados para ' + esc(R.vehicles.format(v)) + '. Comprá lo mismo otra vez sin tener que acordarte qué era.' }));
    body.appendChild(listWrap);
    body.appendChild(addRow);
    renderList();

    function renderList() {
      listWrap.textContent = '';
      var list = R.parts.list(v.id);
      if (!list.length) { listWrap.appendChild(el('div', { class: 'rya-empty' }, [el('div', { class: 'rya-empty__ico', text: '🧰' }), el('p', { text: 'Todavía no tenés repuestos guardados. Guardá uno abajo o desde un mantenimiento.' })])); return; }
      var ul = el('div', { class: 'rya-list' });
      list.forEach(function (p) {
        ul.appendChild(el('div', { class: 'rya-listitem' }, [
          el('div', { class: 'rya-listitem__main' }, [
            el('div', { class: 'rya-listitem__title', text: p.name }),
            p.lastBoughtAt ? el('div', { class: 'rya-listitem__meta', text: 'Última compra: ' + R.ui.date(p.lastBoughtAt) }) : null
          ]),
          el('a', { class: 'rya-btn rya-btn--accent rya-btn--sm', href: R.search.url(p.query || p.name, v), target: '_blank', rel: 'noopener', text: 'Comprar otra vez', onclick: function () { R.parts.touch(p.id); R.track('mc_part_reorder', { name: p.name }); } }),
          el('button', { class: 'rya-iconbtn', 'aria-label': 'Eliminar', text: '🗑', onclick: function () { R.parts.remove(p.id); renderList(); } })
        ]));
      });
      listWrap.appendChild(ul);
    }
  }

  /* ============================ SUPERPODER: viaje ========================= */
  function openViaje(app) {
    R.track('mc_superpower_open', { key: 'viaje' });
    var v = R.vehicles.active();
    var checks = {};
    var body = el('div', { class: 'rya-stack-lg' });
    var sheet = R.ui.sheet({ title: '🛣️ Voy a salir de viaje', content: [body] });

    body.appendChild(el('p', { class: 'rya-sub', text: 'Antes de agarrar carretera, revisá esto. Marcá lo que ya revisaste.' }));
    var checklist = el('div', { class: 'rya-card mc-checklist' }, TRIP_CHECKLIST.map(function (item) {
      var cb = el('input', { type: 'checkbox', class: 'mc-check', onchange: function () { checks[item] = cb.checked; } });
      return el('label', { class: 'mc-checkrow' }, [cb, el('span', { text: item })]);
    }));
    body.appendChild(checklist);

    body.appendChild(el('div', { class: 'rya-row' }, [
      el('button', { class: 'rya-btn rya-btn--whatsapp rya-grow', type: 'button', html: '🟢 Enviar checklist por WhatsApp', onclick: function () { R.track('mc_trip_checklist_send', {}); R.wa.openStore(tripText()); } }),
      el('button', { class: 'rya-btn rya-btn--ghost', type: 'button', text: '📋', 'aria-label': 'Copiar', onclick: function () { R.clipboard.copy(tripText()).then(function (ok) { R.ui.toast(ok ? 'Checklist copiado.' : 'No se pudo copiar.'); }); } })
    ]));

    body.appendChild(el('div', { class: 'rya-card rya-stack' }, [
      el('h3', { class: 'rya-card__title', text: '🧰 Kit de carretera' }),
      el('p', { class: 'rya-muted', style: { fontSize: '13px' }, text: 'Cosas útiles para llevar. Tocá para verlas en ' + esc(R.config.storeName) + '.' }),
      relatedPartsChips(TRIP_KIT, v)
    ]));

    function tripText() {
      var lines = ['Checklist antes de viajar 🛣️'];
      if (v) lines.push('Carro: ' + R.vehicles.format(v));
      TRIP_CHECKLIST.forEach(function (i) { lines.push((checks[i] ? '✅' : '⬜') + ' ' + i); });
      return R.wa.text(lines);
    }
  }

  /* ============================ SUPERPODER: algo raro ===================== */
  function openRaro(app) {
    R.track('mc_superpower_open', { key: 'raro' });
    var v = R.vehicles.active();
    var body = el('div', { class: 'rya-stack' });
    var sheet = R.ui.sheet({ title: '🧰 Algo se siente raro', content: [body] });

    body.appendChild(el('p', { class: 'rya-sub', text: '¿Qué sentís en tu carro? Te ayudamos a explicárselo a tu mecánico con palabras claras.' }));
    body.appendChild(chipGroup(SYMPTOMS, function (item) { renderResult(item); }));

    function renderResult(s) {
      body.textContent = '';
      body.appendChild(el('button', { class: 'rya-link', type: 'button', text: '‹ Elegir otro síntoma', onclick: function () { sheet.close(); openRaro(app); } }));
      var msg = R.wa.text(symptomLines(v, s));
      body.appendChild(el('div', { class: 'rya-card rya-stack' }, [
        el('div', { class: 'rya-between' }, [el('strong', { text: s.emoji + ' ' + s.label }), el('span', { class: 'rya-badge', text: 'Orientativo' })]),
        block('💬 Qué decirle a tu mecánico', el('p', { class: 'mc-quote', text: '“' + s.mecanico + '”' })),
        block('🔍 Qué se podría revisar', listLine(s.revisar)),
        block('❓ Preguntas para tu mecánico', el('ul', { class: 'mc-ul' }, s.preguntar.map(function (p) { return el('li', { text: p }); })))
      ]));
      body.appendChild(relatedPartsBlock(s.parts, v, 'Repuestos que podrían estar relacionados'));
      body.appendChild(el('div', { class: 'rya-alert rya-alert--info' }, [el('span', { class: 'rya-alert__ico', text: 'ℹ️' }), el('span', { text: 'Esto es orientativo y no reemplaza la revisión de un mecánico de confianza.' })]));
      body.appendChild(el('div', { class: 'rya-row', style: { marginTop: '6px' } }, [
        el('button', { class: 'rya-btn rya-btn--accent rya-grow', type: 'button', text: '📋 Copiar para mi mecánico', onclick: function () { R.track('mc_symptom_copy', { symptom: s.key }); R.clipboard.copy(msg).then(function (ok) { R.ui.toast(ok ? 'Copiado.' : 'No se pudo copiar.'); }); } }),
        el('button', { class: 'rya-btn rya-btn--ghost rya-grow', type: 'button', text: '🔧 Abrir reparación', onclick: function () { goToReparacion({ nuevo: 1, v: v ? v.id : '', desde: 'raro' }, { title: s.label, problem: s.mecanico, items: s.parts }); } })
      ]));
    }
  }

  function symptomLines(v, s) {
    var lines = [];
    if (v) lines.push('Carro: ' + R.vehicles.format(v));
    lines.push('Lo que siento: ' + s.mecanico);
    lines.push('Se podría revisar: ' + s.revisar.join(', '));
    lines.push('Pregunta: ' + s.preguntar.join(' '));
    return lines;
  }

  /* ============================ A2HS / instalar =========================== */
  function openInstalar(app) {
    R.track('a2hs_prompt', {});
    var p = R.a2hs.platform();
    var body = el('div', { class: 'rya-stack' }, [
      el('p', { class: 'rya-sub', text: 'Guardá Mi Carro en tu pantalla de inicio. Así lo tenés listo, como una app, para cuando tu carro falle.' }),
      el('div', { class: 'rya-alert rya-alert--info' }, [el('span', { class: 'rya-alert__ico', text: p === 'ios' ? '' : '📲' }), el('span', { text: R.a2hs.instructions(p) })])
    ]);
    var footer = [];
    if (R.a2hs.canPrompt()) footer.push(el('button', { class: 'rya-btn rya-btn--accent', type: 'button', text: 'Instalar ahora', onclick: function () { R.a2hs.prompt(); } }));
    if (R.a2hs.isStandalone()) { body.appendChild(el('div', { class: 'rya-alert rya-alert--info' }, [el('span', { text: '✓ Ya estás usando Mi Carro como app. ¡Listo!' })])); }
    R.ui.sheet({ title: '📲 Agregar a pantalla de inicio', content: [body], footer: footer.length ? footer : null });
  }

  /* ============================ helpers UI ================================ */
  function chipGroup(items, onPick, preselectLabel) {
    var wrap = el('div', { class: 'rya-chips' });
    items.forEach(function (item) {
      var btn = el('button', { class: 'rya-chip' + (preselectLabel && item.label === preselectLabel ? ' is-selected' : ''), type: 'button', onclick: function () {
        wrap.querySelectorAll('.rya-chip').forEach(function (c) { c.classList.remove('is-selected'); });
        btn.classList.add('is-selected'); onPick(item);
      }}, [item.emoji ? el('span', { class: 'rya-chip__emoji', text: item.emoji }) : null, el('span', { text: item.label })]);
      wrap.appendChild(btn);
    });
    return wrap;
  }

  function relatedPartsChips(parts, v) {
    return el('div', { class: 'rya-chips' }, parts.map(function (p) {
      return el('a', { class: 'rya-chip', href: R.search.url(p, v), target: '_blank', rel: 'noopener', onclick: function () { R.track('search_click', { context: 'related_part', name: p }); } }, [el('span', { text: p }), el('span', { class: 'rya-chip__emoji', text: '↗' })]);
    }));
  }
  function relatedPartsBlock(parts, v, title) {
    return el('div', { class: 'rya-card rya-stack' }, [
      el('h3', { class: 'rya-card__title', text: '🛒 ' + title }),
      el('p', { class: 'rya-muted', style: { fontSize: '12.5px' }, text: 'Tocá un repuesto para verlo en ' + esc(R.config.storeName) + '.' }),
      relatedPartsChips(parts, v)
    ]);
  }
  function block(title, node) { return el('div', {}, [el('div', { class: 'mc-block__title', text: title }), node]); }
  function listLine(arr) { return el('p', { class: 'rya-muted', text: arr.join(' · ') }); }
  function urgencyBadge(u) {
    var map = { alta: ['stop', 'Atención'], media: ['warn', 'Revisar pronto'], baja: ['ok', 'Tranquilo'] };
    var m = map[u] || map.media;
    return el('span', { class: 'rya-semaforo rya-semaforo--' + m[0] }, [el('span', { class: 'rya-semaforo__dot' }), el('span', { text: m[1] })]);
  }

  function sendToContact(role, msg, evt, evtData) {
    var c = R.contacts.get()[role];
    if (c && c.phone) { R.track(evt, evtData); R.wa.open(c.phone, msg); return; }
    // pedir número inline
    var input = el('input', { class: 'rya-input', type: 'tel', inputmode: 'numeric', placeholder: '9999-9999' });
    var name = el('input', { class: 'rya-input', placeholder: role === 'mechanic' ? 'Nombre del mecánico (opcional)' : 'Nombre (opcional)' });
    R.ui.sheet({
      title: role === 'mechanic' ? 'Número de tu mecánico' : 'Número del familiar',
      content: [el('p', { class: 'rya-sub', text: 'Guardamos el número en este teléfono para la próxima vez.' }), el('div', { class: 'rya-stack' }, [name, input])],
      footer: [el('button', { class: 'rya-btn rya-btn--whatsapp', type: 'button', text: 'Guardar y enviar', onclick: function (ev) {
        var phone = (input.value || '').trim(); if (!phone) { input.focus(); return; }
        R.contacts.set(role, { name: (name.value || '').trim(), phone: phone });
        R.track(evt, evtData); R.wa.open(phone, msg);
        var root = ev.currentTarget.closest('.rya-sheet'); if (root) root.querySelector('.rya-sheet__close').click();
      } })]
    });
  }

  /* ============================ cross-link a Mi Reparación ================ */
  function goToReparacion(params, draft) {
    if (draft) {
      R.store.set('ryauto:v1:repairDraft', { vehicleId: params.v || '', title: draft.title || '', problem: draft.problem || '', items: draft.items || [], from: params.desde || '', at: Date.now() });
      // también por URL, para sobrevivir el modo privado de iOS (memStore se pierde al navegar)
      if (draft.title) params.t = draft.title;
      if (draft.problem) params.p = draft.problem;
      if (draft.items && draft.items.length) params.items = draft.items.join('|');
    }
    var q = Object.keys(params).filter(function (k) { return params[k] !== '' && params[k] != null; }).map(function (k) { return k + '=' + encodeURIComponent(params[k]); }).join('&');
    window.location.href = withQuery(R.config.reparacionUrl, q);
  }

  function withQuery(base, query) {
    if (!query) return base;
    var hash = '';
    var hashIndex = base.indexOf('#');
    if (hashIndex >= 0) {
      hash = base.slice(hashIndex);
      base = base.slice(0, hashIndex);
    }
    return base + (base.indexOf('?') >= 0 ? '&' : '?') + query + hash;
  }

  /* ============================ arranque ================================== */
  if (window.RYAuto) window.RYAuto.ready(boot);
  else document.addEventListener('DOMContentLoaded', function () { if (window.RYAuto) window.RYAuto.ready(boot); });
})();
